// extracted by mini-css-extract-plugin
export var container = "styles_container__jYK8e";
export var stars = "styles_stars__KYyqf";
export var subtitle = "styles_subtitle__4KwHV";
export var title = "styles_title__iSt7y";